// #ux-redesign-start: InboxBody — copia 1:1 del patrón Doctors adaptado a Patients.
// Antes: branches por flag `mobile` que renderizaban InboxMobileDetail vs
// InboxViewDetail. Ahora: un solo árbol — el responsive lo gobierna CSS. El
// "back" mobile es un botón del toolbar (visible solo cuando hay detail/form
// abierto + viewport ≤md).
// ─────────────────────────────────────────────────────────────────────────────
import React, { useEffect, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useTranslate } from 'react-translate';
import { useHistory, useParams } from 'react-router';

import Actions from '../Actions/Actions';
import InboxSearcher from '../InboxSearcher';
import InboxViewList from './InboxViewList';
import InboxViewDetail from './InboxViewDetail';
import InboxViewForm from './InboxViewForm';

import useResponsive from 'hooks/useResponsive';
import {
  actionSetMessage,
  actionGetMessage,
} from 'store/actions/messagesActions';

const InboxBody = ({ showForm, setShowForm, onBack }) => {
  const t = useTranslate('messages');
  const dispatch = useDispatch();
  const history = useHistory();
  const { id } = useParams();

  const [reply, setReply] = useState(false);
  const [resend, setResend] = useState(false);

  const { message, box } = useSelector((state) => state.messagesReducer);
  const { isMobile } = useResponsive();
  const mobile = isMobile;

  const detailOpen = !!message || showForm;

  const handleBack = () => {
    dispatch(actionSetMessage());
    setShowForm(false);
  };

  const handleBackToFolders = () => {
    if (onBack) onBack();
  };

  // Deep-link a un mensaje desde URL (ej. notificación push)
  useEffect(() => {
    if (id && id !== ':id' && (!message || message?._id !== id)) {
      dispatch(actionGetMessage(id));
      history.replace('/admin/inbox');
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id]);

  return (
    <>
      <div className="inbox-main-toolbar">
        {detailOpen && (
          <button
            type="button"
            className="inbox-main-toolbar__back"
            onClick={handleBack}
            aria-label={t('go-back') || 'Back'}
          >
            <i className="fas fa-arrow-left" aria-hidden="true" />
          </button>
        )}
        {!detailOpen && isMobile && onBack && (
          <button
            type="button"
            className="inbox-main-toolbar__folders"
            onClick={handleBackToFolders}
            aria-label={t('open-folders') || 'Folders'}
          >
            <i className="fas fa-bars" aria-hidden="true" />
          </button>
        )}
        {!detailOpen && (
          <div className="inbox-main-toolbar__search">
            <InboxSearcher box={box} />
          </div>
        )}
        <Actions
          setShowForm={setShowForm}
          mobile={mobile}
          setReply={setReply}
          setResend={setResend}
        />
      </div>

      <div className="inbox-main-body">
        {!message && !showForm && (
          <InboxViewList setShowForm={setShowForm} mobile={mobile} />
        )}

        {message && !showForm && (
          <InboxViewDetail key={message._id || 0} mobile={mobile} />
        )}

        {showForm && (
          <InboxViewForm
            setShowForm={setShowForm}
            mobile={mobile}
            resend={resend}
            reply={reply}
            setReply={setReply}
          />
        )}
      </div>
    </>
  );
};

export default InboxBody;
// #ux-redesign-end
